module.exports = __webpack_public_path__ + "static/media/metro_logo.9545d595.png";